<script>
  export let value;
  export let label = undefined;
  export let type = 'text';
  export let placeholder = undefined;
  export let disabled = false;
  export let icon = undefined;
  export let prepend = undefined;
  export let focus = true;
  export let error = undefined;
  export let translate = undefined;
  export let onTranslateClick = undefined;
  export let characters = undefined;
</script>

<div class='input'
  class:input-with-icon={icon}
  class:input-with-prepend={prepend}
  class:input-no-focus={!focus}
  class:input-with-error={error}>

  {#if label} <div class='input-label'> {label} </div> {/if}

  {#if translate} <div class='input-translate' on:click={onTranslateClick}> {translate} </div> {/if}

  {#if icon} <div class='input-icon'> <span class='material-icons'> {icon} </span> </div> {/if}

  {#if prepend} <div class='input-prepend'> {prepend} </div> {/if}

  {#if type === 'number'}
    <input type='number' bind:value={value} placeholder={placeholder} disabled={disabled}/>
  {:else if type === 'password'}
    <input type='password' bind:value={value} placeholder={placeholder} disabled={disabled}/>
  {:else}
    <input type='text' bind:value={value} placeholder={placeholder} disabled={disabled}/>
  {/if}

  {#if characters} <div class='input-characters'> {value?.length || 0} / {characters} </div> {/if}

  {#if error} <div class='input-error'> {error.replace(/ ".+" /, ' ')} </div> {/if}
</div>

<style>
  .input {
    position: relative;

    display: flex;

    width: 100%;
  }

  .input-label {
    position: absolute;
    top: -7px;
    left: 10px;

    display: flex;
    align-items: center;

    height: 15px;

    padding: 0px 5px;

    border-radius: var(--radius-sm);

    font-size: 12px;
    font-weight: 550;

    background: var(--white);
    color: var(--grey-9);
  }

  .input-translate {
    position: absolute;
    top: -7px;
    right: 10px;

    display: flex;
    align-items: center;

    height: 15px;

    padding: 0px 5px;

    border-radius: var(--radius-sm);

    text-transform: uppercase;
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-decoration-color: transparent;

    font-size: 12px;
    font-weight: 550;

    letter-spacing: 1.2px;

    background: var(--white);
    color: var(--blue-8);

    cursor: pointer;

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .input-translate:hover {
    text-decoration-color: var(--blue-8);
  }

  .input-icon {
    position: absolute;
    top: 0px;
    left: 5px;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 20px;
    height: 20px;

    margin: 10px;

    color: var(--grey-5);
  }

  .input-prepend {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;

    width: 250px;
    height: 40px;

    padding: 9px 14px;

    box-sizing: border-box;
    border: 1px solid var(--grey-5);
    border-right: none;
    border-radius: var(--radius-lg) 0px 0px var(--radius-lg);

    font-family: var(--font-primary);
    font-size: 16px;

    background: var(--grey-1);
    color: var(--grey-5);

    overflow: hidden;

    white-space: nowrap;
  }

  .input input {
    display: flex;
    align-items: center;

    width: 100%;
    height: 40px;

    padding: 9px 14px;

    box-sizing: border-box;
    border: 1px solid var(--grey-5);
    border-radius: var(--radius-lg);

    font-family: var(--font-primary);
    font-size: 16px;

    background: var(--white);

    outline: none;

    transition: border 0.25s ease-in-out;

    --tw-ring-color: transparent;
  }

  .input input[type=number] {
    appearance: textfield;
  }

  .input:not(.input-no-focus):not(.input-with-error) input:focus {
    border: 1px solid var(--grey-9);
  }

  .input input:disabled {
    background: var(--grey-1);
    color: var(--grey-5) !important;
  }

  .input-characters {
    position: absolute;
    bottom: -7px;
    left: 10px;

    display: flex;
    align-items: center;

    height: 15px;

    padding: 0px 5px;

    border-radius: var(--radius-sm);

    font-size: 12px;
    font-weight: 550;

    background: var(--white);
    color: var(--grey-5);

    transition: color 0.25s ease-in-out;
  }

  input:focus + .input-characters {
    color: var(--grey-9);
  }

  .input-error {
    position: absolute;
    bottom: -7px;
    right: 10px;

    display: flex;
    align-items: center;

    height: 15px;
    max-width: calc(100% - 30px);

    padding: 0px 5px;

    border-radius: var(--radius-sm);

    font-size: 12px;
    font-weight: 550;

    background: var(--white);
    color: var(--red-8);

    overflow: hidden;

    white-space: nowrap;
  }

  .input-with-icon input {
    padding-left: 45px;
  }

  .input-with-prepend input {
    border-radius: 0px var(--radius-lg) var(--radius-lg) 0px;
  }

  .input-with-prepend .input-icon {
    left: 255px;
  }

  .input-with-error input {
    border: 1px solid var(--red-8);
  }

  .input input:-webkit-autofill {
    background: var(--yellow-1) !important;
  }

  .input input::-webkit-outer-spin-button,
  .input input::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  ::placeholder {
    color: var(--grey-5);

    opacity: 1;
  }

  :global(body.dark) .input-label {
    background: var(--grey-9);
    color: var(--grey-4);
  }

  :global(body.dark) .input-translate {
    background: var(--grey-9);
    color: var(--blue-3);
  }

  :global(body.dark) .input-translate:hover {
    text-decoration-color: var(--blue-3);
  }

  :global(body.dark) .input-icon {
    color: var(--grey-6);
  }

  :global(body.dark) .input-prepend {
    border: 1px solid var(--grey-6);
    border-right: none;

    background: var(--grey-8);
    color: var(--grey-6);
  }

  :global(body.dark) .input input {
    border: 1px solid var(--grey-6);

    background: var(--grey-9);
    color: var(--grey-3);
  }

  :global(body.dark) .input:not(.input-no-focus):not(.input-with-error) input:focus {
    border: 1px solid var(--grey-4);
  }

  :global(body.dark) .input input:disabled {
    background: var(--grey-8);
    color: var(--grey-6) !important;
  }

  :global(body.dark) .input-characters {
    background: var(--grey-9);
    color: var(--grey-6);
  }

  :global(body.dark) input:focus + .input-characters {
    color: var(--grey-4);
  }

  :global(body.dark) .input-error {
    background: var(--grey-9);
    color: var(--red-3);
  }

  :global(body.dark) .input-with-error input {
    border: 1px solid var(--red-3);
  }

  :global(body.dark) .input input:-webkit-autofill {
    background: var(--yellow-1) !important;
    color: var(--black);
  }

  :global(body.dark) ::placeholder {
    color: var(--grey-6);
  }

  @media only screen and (max-width: 600px) {
    .input-prepend {
      width: 125px;
    }

    .input-with-prepend .input-icon {
      left: 130px;
    }
  }
</style>
